import React from 'react';
import { Link } from '../components/atoms/Link';
import { isSupportedLinkPreviewUrl } from '../components/molecules/LinkWithPreview/supportedLinkPreview.ts';
import {
    splitTextIntoLinkParts,
} from '../utils/linkDetection';

/**
 * Custom hook that keeps links inline and returns supported preview urls separately
 * @returns {Function} Function that takes content and returns inline content plus preview urls
 */
export const useClickableLinks = () => {
    const renderTextWithLinks = React.useCallback((content) => {
        if (!content || typeof content !== 'string') {
            return {
                content,
                previews: [],
            };
        }

        const previewUrls = [];
        const seenPreviewUrls = new Set();
        const renderedContent = splitTextIntoLinkParts(content).map((part, index) => {
            if (part.type !== 'url') {
                return part.value;
            }

            if (!part.url) {
                return part.original;
            }

            if (isSupportedLinkPreviewUrl(part.url) && !seenPreviewUrls.has(part.url)) {
                seenPreviewUrls.add(part.url);
                previewUrls.push(part.url);
            }

            return (
                <React.Fragment key={`link-${index}`}>
                    <Link
                        to={part.url}
                        external={true}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {part.url}
                    </Link>
                    {part.trailingText}
                </React.Fragment>
            );
        });

        return {
            content: renderedContent,
            previews: previewUrls,
        };
    }, []);

    return renderTextWithLinks;
};
